module.exports = __webpack_public_path__ + "media/Video 15.383e91c1.mp4";